// src/components/Dashboard/StatsCards.tsx
import React from 'react'
import {Users, CreditCard, DollarSign, Activity} from 'lucide-react'
import {formatUSD} from '../../utils/helpers'

interface StatsCardsProps {
    stats: any
}

const StatsCards: React.FC<StatsCardsProps> = ({stats}) => {
    const cards = [
        {
            title: 'المستخدمين',
            value: stats?.totalUsers || 0,
            icon: Users,
            color: 'bg-blue-500'
        },
        {
            title: 'المعاملات',
            value: stats?.totalTransactions || 0,
            icon: CreditCard,
            color: 'bg-green-500'
        },
        {
            title: 'حجم التداول',
            value: formatUSD(stats?.totalVolumeUSD || 0),
            icon: DollarSign,
            color: 'bg-purple-500'
        },
        {
            title: 'النشطين اليوم',
            value: stats?.todayStats?.count || 0,
            icon: Activity,
            color: 'bg-orange-500'
        }
    ]

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {cards.map((card, index) => {
                const Icon = card.icon
                return (
                    <div key={index} className="bg-white rounded-xl shadow-sm p-6 border border-gray-200">
                        <div className="flex items-center justify-between mb-4">
                            <div className={`${card.color} p-3 rounded-lg`}>
                                <Icon className="w-5 h-5 text-white" />
                            </div>
                        </div>
                        <p className="text-sm text-gray-500 mb-1">{card.title}</p>
                        <p className="text-2xl font-bold text-gray-800">{card.value}</p>
                    </div>
                )
            })}
        </div>
    )
}

export default StatsCards